import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";
var _templateObject;
import { css, memoizeStyle, prefix } from "../../../lib/theming/Emotion";
import { UI_FONT_NAME } from "../../../lib/styles/UiFont";
export var globalClasses = prefix('masked-input')({
  root: 'root'
});
export var styles = memoizeStyle({
  root: function root(t) {
    return css(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n      font-family: ", ", ", ";\n      font-variant-numeric: tabular-nums;\n    "])), UI_FONT_NAME, t.baseFontFamily);
  }
});